import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get ApiLogs
export const getApiLogs = createAsyncThunk("apiLogs/getApiLogs", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getApiLogs({
      rowsPerPage: rowsPerPage,
      search,
      sortOrder,
      pageNo,
    });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all ApiLogs
export const getAllApiLogs = createAsyncThunk("apiLogs/getAllApiLogs", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllApiLogs();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("apiLogs/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("apiLogs/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("apiLogs/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;

  try {
    const { data } = await API.getPageApiLogs({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get ApiLogs by item
export const getSpecificApiLogs = createAsyncThunk("apiLogs/getSpecificApiLogs", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getSpecificApiLogs(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// handle search
export const handleSearch = createAsyncThunk("apiLogs/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
